import { render, staticRenderFns } from "./personAddNew.vue?vue&type=template&id=52eb6abe&scoped=true"
import script from "./personAddNew.vue?vue&type=script&lang=js"
export * from "./personAddNew.vue?vue&type=script&lang=js"
import style0 from "./personAddNew.vue?vue&type=style&index=0&id=52eb6abe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb6abe",
  null
  
)

export default component.exports